/* eslint-disable func-names */
import { useState } from 'react';
import { Select, Space } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import ArrowLineIcon from 'Components/common/assets/svgIcons/ArrowLineIcon';
import moment from 'moment';

interface TimeRangePickerProps {
  startTime: string
  endTime: string
  handleStartTimeChange: (val: string) => void
  filteredEndTimeOptions: () => string[]
  handleEndTimeChange: (val: string) => void
}

function generateTimeOptions() {
  const options = [];
  for (let hour = 0; hour < 24; hour += 1) {
    for (let minute = 0; minute < 60; minute += 30) {
      options.push(moment().hour(hour).minute(minute).format('h:mm A'));
    }
  }
  return options;
}

export const OutlookStyleTimePicker = function ({
  startTime, endTime, handleStartTimeChange, filteredEndTimeOptions, handleEndTimeChange,
}: TimeRangePickerProps) {
  const [timeOptions] = useState<string[]>(generateTimeOptions());

  return (
    <Space direction="horizontal" className="time-picker">
      <div>
        <Select
          style={{ width: '100%' }}
          value={startTime}
          onChange={handleStartTimeChange}
          suffixIcon={<ClockCircleOutlined />}
          popupClassName="time-picker-dropdown"
        >
          {timeOptions.map((time) => (
            <Select.Option key={time} value={time}>
              {time}
            </Select.Option>
          ))}
        </Select>
      </div>
      <div><ArrowLineIcon color="#000" /></div>
      <div>
        <Select
          style={{ width: '100%' }}
          value={endTime}
          onChange={handleEndTimeChange}
          suffixIcon={<ClockCircleOutlined />}
          popupClassName="time-picker-dropdown"
        >
          {filteredEndTimeOptions().map((time) => (
            <Select.Option key={time} value={time}>
              {time}
            </Select.Option>
          ))}
        </Select>
      </div>
    </Space>
  );
};
